import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Requesting Pages
import Home from './pages/Home';
import About from './pages/About';
import ServicesPage from './pages/ServicesPage';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import AiHub from './pages/AiHub';
import AnimatedBackground from './components/AnimatedBackground';
import FloatingAIAssistant from './components/FloatingAIAssistant';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col relative">
        <AnimatedBackground />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/ai-assistant" element={<AiHub />} />
            <Route path="/ai" element={<Navigate to="/ai-assistant" replace />} />
          </Routes>
        </main>
        <Footer />
        {/* Global Sitewide Floating Conversational AI Assistant */}
        <FloatingAIAssistant />
      </div>
    </BrowserRouter>
  );
}

export default App;
